(function (){
    'use strict';

    angular
        .module('costCenters', []);
})();